import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import EventApi from "../services/event";

function useMaterialsData(autoFetch = false) {
    const [materials, setMaterials] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchMaterials = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await EventApi.listMaterials();
            if (response?.data?.data) {
                const fetchedMaterials = response.data.data;
                setMaterials(fetchedMaterials);
                return fetchedMaterials;
            } else {
                throw new Error("Failed to fetch materials");
            }
        } catch (error) {
            console.error("Error fetching materials:", error);
            setError(error);
            toast.error("Não foi possível carregar os materiais. Tente novamente.");
            return false;
        } finally {
            setLoading(false);
        }
    };

    const newMaterial = async (data) => {
        setLoading(true);
        setError(null);
        try {
            const response = await EventApi.createMaterial(data);
            console.log(response);
            if (response?.data) {
                const createdMaterial = response.data;
                return createdMaterial;
            } else {
                throw new Error("Failed to fetch materials");
            }
        } catch (error) {
            console.error("Error creating material:", error);
            setError(error);
            toast.error("Não foi possível adicionar. Tente novamente.");
            return false;
        } finally {
            setLoading(false);
        }
    };

    const updateMaterial = async (id, data) => {
        setLoading(true);
        setError(null);
        try {
            const response = await EventApi.updateMaterial(id, data);
            if (response?.data?.data) {
                const updatedMaterial = response.data.data;
                return updatedMaterial;
            } else {
                throw new Error("Failed to update materials");
            }
        } catch (error) {
            console.error("Error updating material:", error);
            setError(error);
            toast.error("Não foi possível atualizar. Tente novamente.");
            return false;
        } finally {
            setLoading(false);
        }
    };

    const deleteMaterial = async (id) => {
        setLoading(true);
        setError(null);
        try {
            const response = await EventApi.deleteMaterial(id);
            if (response?.data?.data) {
                return true;
            } else {
                throw new Error("Failed to delete material");
            }
        } catch (error) {
            console.error("Error deleting material:", error);
            setError(error);
            toast.error("Não foi possível deletar. Tente novamente.");
            return false;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (autoFetch) {
            fetchMaterials();
        }
    }, [autoFetch]);

    return {
        materials,
        loading,
        error,
        fetchMaterials,
        newMaterial,
        updateMaterial,
        deleteMaterial,
    };
}

export default useMaterialsData;
